import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class WhatsnewService {
  constructor(private http: HttpClient) {}

  getwhatsnewData() {
    const jsonUrl = 'assets/whatsNewData.json';
    return this.http.get(jsonUrl);
  }
}
